/* Codressing: sentence case for button labels typed in capitals ("MAKE AN OFFER" -> "Make an offer").
   Loaded site-wide (defer) from layout/theme.liquid. CSS text-transform is handled in assets/cd-buttons.css;
   this script fixes labels whose text itself is written in capitals, including app buttons that render late.
   - Only buttons: button, .button, .btn, input[type=submit|button] values, a[class*=button], a[class*=btn], [role=button]
     and the payment/app buttons below. Never header/nav/menu items, the mobile drawer, headings, logos or the press strip.
   - Only labels that are ALL UPPERCASE (letters only, more than one letter). Short single tokens (XS, XL, EU, OK) are left.
   - Brand words are restored: WhatsApp, Codressing, Google, Instagram, EU.
   - Open shadow roots of app custom elements are processed too. */
(function () {
  'use strict';
  if (window.__cdSentenceCase) return;
  window.__cdSentenceCase = true;

  var BTN = [
    'button', '.button', '.btn', 'input[type="submit"]', 'input[type="button"]',
    'a[class*="button"]', 'a[class*="btn"]', '[role="button"]',
    '.shopify-payment-button__button', '.cd-plan__cta',
    '[class*="make-an-offer"] a', '[class*="make-offer"] a', 'make-an-offer-badge a', 'make-an-offer-badge button'
  ].join(',');

  var SKIP = [
    '#header', 'header', 'nav', '.header', '.thb-full-menu', '.thb-mobile-menu', '.cd-md', '.cd-mega',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', '.cd-hero-press', '[class*="cd-hp"]', '.dot-style--logos', '.logo-list',
    '.cd-hdr-ctas', '.flickity-page-dots', '[contenteditable="true"]', '[data-cd-keep-case]',
    '.variant-picker', '.product-form__input', '.cd-sizes', 'select', 'option'
  ].join(',');

  var BRANDS = [
    [/\bwhatsapp\b/g, 'WhatsApp'],
    [/\bcodressing\b/g, 'Codressing'],
    [/\bgoogle\b/g, 'Google'],
    [/\binstagram\b/g, 'Instagram'],
    [/\beu\b/g, 'EU']
  ];

  var LETTER = /[A-Za-zÀ-ÖØ-öø-ÿĀ-ſ]/;
  var LETTERS = /[A-Za-zÀ-ÖØ-öø-ÿĀ-ſ]/g;

  function skipPage() {
    var c = document.body ? document.body.className : '';
    /* lookbooks use brand names as button labels (GANNI, BA&SH...) */
    return /template-page-lookbook/.test(c);
  }

  function isAllCaps(text) {
    var letters = text.match(LETTERS);
    if (!letters || letters.length < 2) return false;
    var joined = letters.join('');
    if (joined !== joined.toUpperCase() || joined === joined.toLowerCase()) return false;
    var trimmed = text.trim();
    /* single short token: sizes and acronyms */
    if (!/\s/.test(trimmed) && letters.length <= 3) return false;
    return true;
  }

  function fixBrands(s) {
    for (var i = 0; i < BRANDS.length; i++) s = s.replace(BRANDS[i][0], BRANDS[i][1]);
    return s;
  }

  function sentence(s, capFirst) {
    var out = s.toLowerCase();
    if (capFirst) {
      var m = out.search(LETTER);
      if (m > -1) out = out.slice(0, m) + out.charAt(m).toUpperCase() + out.slice(m + 1);
    }
    return fixBrands(out);
  }

  function textNodes(el) {
    var list = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = walker.nextNode())) {
      var p = n.parentNode;
      if (p && (p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE' || p.nodeName === 'svg' || p.closest && p.closest('svg'))) continue;
      if (n.nodeValue && n.nodeValue.trim()) list.push(n);
    }
    return list;
  }

  function convert(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.closest && el.closest(SKIP)) return;
    if (el.tagName === 'INPUT') {
      var v = el.value || '';
      if (isAllCaps(v)) el.value = sentence(v, true);
      return;
    }
    /* nested buttons: let the innermost one decide */
    if (el.querySelector && el.querySelector(BTN)) return;
    var nodes = textNodes(el);
    if (!nodes.length) return;
    var full = '';
    for (var i = 0; i < nodes.length; i++) full += nodes[i].nodeValue + ' ';
    if (full.length > 80 || !isAllCaps(full)) return;
    var first = true;
    for (var j = 0; j < nodes.length; j++) {
      var val = nodes[j].nodeValue;
      var next = sentence(val, first);
      if (first && LETTER.test(val)) first = false;
      if (next !== val) nodes[j].nodeValue = next;
    }
  }

  var SHADOW_CSS = 'button,.button,.btn,a[class*="button"],a[class*="btn"],[role="button"],input[type="submit"]{text-transform:none!important}' +
    /* Supercycle rental durations in 2 columns, in case the widget ever renders in a shadow root (see cd-buttons.css) */
    '.supercycle-method--calendar :has(> .supercycle-options__option),:has(> .supercycle-options__option[data-supercycle-option-name*="day" i]){display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important}';

  function run(root) {
    var scope = root || document;
    var els = scope.querySelectorAll(BTN);
    for (var i = 0; i < els.length; i++) convert(els[i]);
    /* open shadow roots of app custom elements */
    var all = scope.querySelectorAll('*');
    for (var k = 0; k < all.length; k++) {
      var sr = all[k].shadowRoot;
      if (sr && all[k].tagName.indexOf('-') > -1) {
        if (!sr.__cdCase) {
          sr.__cdCase = true;
          try {
            var st = document.createElement('style');
            st.textContent = SHADOW_CSS;
            sr.appendChild(st);
          } catch (e) {}
          try { observer && observer.observe(sr, { childList: true, subtree: true, characterData: true }); } catch (e) {}
        }
        run(sr);
      }
    }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 150);
  }

  var observer = window.MutationObserver ? new MutationObserver(schedule) : null;

  function start() {
    if (skipPage()) return;
    run();
    if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
